/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { IdentityUserAri } from '@atlassian/ari/identity/user';
import { expVal } from '@atlassian/jira-feature-experiments';
import { JiraNavigationSettingsAri } from '@atlassian/ari/jira/navigation-settings';
import { fg } from '@atlassian/jira-feature-gating';
import { NavigationSettingAri } from '@atlassian/ari/navigation/setting';
import type { Nav4AppsContentViewQueryEntrypointProps } from './Nav4AppsContentViewQuery.entrypoint.types.tsx';
import parameters, {
	type Nav4AppsContentViewQuery,
} from './__generated__/Nav4AppsContentViewQuery.graphql';

type Queries = { apps: Nav4AppsContentViewQuery };

type EntryPointParams = {
	cloudId: string;
	accountId?: string;
	activationId?: string;
	currentURL?: string;
};

type AsyncNav4AppsContentViewQueryComponent = EntryPointComponent<
	Queries,
	{},
	Nav4AppsContentViewQueryEntrypointProps,
	{}
>;

export const asyncNav4AppsContentViewQuery: EntryPoint<
	AsyncNav4AppsContentViewQueryComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AsyncNav4AppsContentViewQueryComponent>(
		/* webpackChunkName: "async-nav4-apps-content-view-query" */ './Nav4AppsContentViewQuery.tsx',
	),
	getPreloadProps: (params: EntryPointParams) => {
		const cloudId = params.cloudId || '';
		const activationId = params.activationId || '';

		const variables = {
			cloudId,
			entityAriApps: '',
			ownerAri: '',
			skipOrderQuery: true,
		};

		if (expVal('navx-2365-add_dnd_to_jira_l2_menu_items', 'isEnabled', false)) {
			const entityAriApps = fg('navx-3660-fix-l2-l3-aris')
				? NavigationSettingAri.create({
						activationId,
						firstPartyApp: 'jira',
						settingId: 'jira-apps',
						siteId: cloudId,
					}).toString()
				: JiraNavigationSettingsAri.create({
						siteId: cloudId,
						activationId,
						navigationSettingScope: 'apps',
					}).toString();

			const ownerAri = IdentityUserAri.create({
				userId: params.accountId || 'UNKNOWN',
			}).toString();
			variables.entityAriApps = entityAriApps;
			variables.ownerAri = ownerAri;
			variables.skipOrderQuery = false;
		}

		return {
			queries: {
				apps: {
					parameters,
					variables,
				},
			},
		};
	},
});
